// Admin console wireframe — mock data (front-end only).
// FICTIONAL DATA ONLY. Never seed this file from the real client list: names and numbers here are
// invented and every number uses the reserved 555 block so it cannot belong to a real subscriber.

export const CUSTOMERS = [
  { id: "c1", name: "Maryanne Bekker", cell: "+27 82 555 0188", insurer: "Simah", plan: "Family", product: "consumer", hasApp: true, incidents: 2, status: "active" },
  { id: "c2", name: "Renier Wessels", cell: "+27 83 555 0147", insurer: "Indwe", plan: "Couple", product: "consumer", hasApp: true, incidents: 0, status: "active" },
  { id: "c3", name: "Anthea Fourie", cell: "+27 82 555 0130", insurer: "Indwe", plan: "Single", product: "consumer", hasApp: false, incidents: 1, status: "active" },
  { id: "c4", name: "Johan Bekker", cell: "+27 81 555 0182", insurer: "Indwe", plan: "Family", product: "consumer", hasApp: true, incidents: 3, status: "active" },
  { id: "c5", name: "Dr T. Naidoo", cell: "+27 83 555 0139", insurer: "BornmanMarlow", plan: "Couple", product: "consumer", hasApp: true, incidents: 1, status: "active" },
  { id: "c6", name: "Barbara Lindeque", cell: "+27 84 555 0172", insurer: "BornmanMarlow", plan: "Single", product: "consumer", hasApp: false, incidents: 0, status: "lead" },
  { id: "c7", name: "Demo Fleet Depot (Fleet)", cell: "+27 66 555 0113", insurer: "Enviroserve", plan: "Fleet · 34 drivers", product: "commercial", hasApp: true, incidents: 5, status: "active" },
  { id: "c8", name: "Alex Mabaso", cell: "+27 67 555 0129", insurer: "Enviroserve", plan: "Driver", product: "commercial", hasApp: true, incidents: 0, status: "active" },
  { id: "c9", name: "Demo API Partner", cell: "+27 11 555 0184", insurer: "Direct", plan: "API partner", product: "commercial", hasApp: false, incidents: 8, status: "active" },
];

export const REQUESTS = [
  { id: "RSQ-2026-0042", name: "Johan Bekker", cell: "+27 81 555 0182", type: "Security", partner: "Indwe", product: "consumer", elapsed: "0m 47s", battery: 18, urgent: true },
  { id: "RSQ-2026-0041", name: "Maryanne Bekker", cell: "+27 82 555 0188", type: "Medical", partner: "Simah", product: "consumer", elapsed: "2m 14s", battery: 62 },
  { id: "RSQ-2026-0040", name: "Demo Fleet · BH00VTGP", cell: "+27 63 555 0160", type: "Roadside", partner: "Enviroserve", product: "commercial", elapsed: "6m 03s", battery: 81 },
];

export const TIMELINE = [
  { t: "14:32:04", e: "Dispatched to control room (mock)", tag: "dispatch" },
  { t: "14:31:58", e: "Location resolved · Constantia, WC", tag: "info" },
  { t: "14:31:55", e: "SOP attached · Simah residential", tag: "info" },
  { t: "14:31:52", e: "PANIC signal received", tag: "panic" },
];

export const INSURERS = [
  { name: "Indwe", clients: 2394, distributors: [
    { name: "Indwe Risk Services", agents: [{ name: "J. Kruger", code: "ef7e9e", clients: 812 }, { name: "M. Naidoo", code: "a9bd83", clients: 640 }] },
    { name: "Indwe Coastal", agents: [{ name: "P. Botha", code: "c41d7a", clients: 942 }] },
  ] },
  { name: "Enviroserve", clients: 203, distributors: [
    { name: "Enviroserve Fleet", agents: [{ name: "T. Mokoena", code: "7b2e90", clients: 203 }] },
  ] },
  { name: "Simah", clients: 200, distributors: [
    { name: "Simah Direct", agents: [{ name: "R. Adams", code: "d38f12", clients: 200 }] },
  ] },
  { name: "BornmanMarlow", clients: 138, distributors: [
    { name: "BornmanMarlow Brokers", agents: [{ name: "L. van Wyk", code: "9a55c1", clients: 138 }] },
  ] },
];

export const LEAD_STAGES = [
  { stage: "New lead", count: 42 },
  { stage: "Link opened", count: 28 },
  { stage: "Info provided", count: 17 },
  { stage: "Debit order", count: 9 },
  { stage: "Activated", count: 6 },
];

export const LEADS = [
  { name: "Thabo Molefe", agent: "J. Kruger (ef7e9e)", stage: "Info provided", created: "11 Feb" },
  { name: "Sarah Wentzel", agent: "M. Naidoo (a9bd83)", stage: "Link opened", created: "10 Feb" },
  { name: "Yusuf Patel", agent: "P. Botha (c41d7a)", stage: "Debit order", created: "09 Feb" },
  { name: "Nomsa Dube", agent: "R. Adams (d38f12)", stage: "New lead", created: "08 Feb" },
];

export const SEGMENTS = [
  { name: "App downloaders — all", type: "Dynamic", count: 1063, filter: "Has app = Yes" },
  { name: "Not onboarded — Indwe", type: "Dynamic", count: 1639, filter: "Insurer = Indwe · Has app = No" },
  { name: "Simah — Family plans", type: "Snapshot", count: 84, filter: "Insurer = Simah · Plan = Family (frozen 12 Feb)" },
];

export const CAMPAIGNS = [
  { name: "Welcome to ResQ1", channel: "Email", segment: "App downloaders — all", status: "Sent", recipients: 1063, delivered: 1041, date: "12 Feb" },
  { name: "Finish your setup", channel: "Email", segment: "Not onboarded — Indwe", status: "Draft", recipients: 1639, delivered: 0, date: "—" },
  { name: "Scheduled maintenance notice", channel: "Email", segment: "App downloaders — all", status: "Scheduled", recipients: 1063, delivered: 0, date: "16 Feb 02:00" },
];

export const REPORTS = [
  { name: "Clients per Insurer", desc: "Headcount + app adoption grouped by insurer", rows: "4 insurers" },
  { name: "Client Details per Insurer", desc: "Full client roster with contact + status", rows: "2,935 records" },
  { name: "Help Request Activity", desc: "Incidents by client, outcome and response time", rows: "SLA rollup" },
  { name: "Agent Commission Statement", desc: "Per-agent commission by hierarchy level", rows: "6 agents" },
  { name: "Distributor Lead Funnel", desc: "Lead → activation conversion by distributor", rows: "5 stages" },
];

export const ADMINS = [
  { name: "Gordon Bosman", email: "gordonbosman4@gmail.com", role: "Owner · Admin", status: "active" },
  { name: "Genevieve", email: "genevieve@resq1.co.za", role: "COO · Admin", status: "invite pending" },
];

export const INTEGRATIONS = [
  { name: "CSG Connect (dispatch)", state: "Mock", note: "CSG_LIVE_ENABLED = false", ok: false },
  { name: "Resend (email)", state: "Connected", note: "PROD_EMAIL_ENABLED = false · test-only", ok: true },
  { name: "Twilio (WhatsApp)", state: "Dormant", note: "Awaiting credentials", ok: false },
  { name: "OpenAI (parsing)", state: "Connected", note: "Emergent LLM key", ok: true },
];

export const GATES = [
  { key: "CSG_LIVE_ENABLED", value: "false", desc: "Real CSG dispatch calls — off in every environment until flipped" },
  { key: "PROD_EMAIL_ENABLED", value: "false", desc: "Live customer emails — off; sends restricted to allowlist" },
  { key: "TEST_EMAIL_ALLOWLIST", value: "gordonbosman4@gmail.com", desc: "Only address that receives mail in non-prod" },
];

export const MIGRATION = {
  total: 2935, unique: 2923, duplicates: 12, hasApp: 1063,
  files: [
    { src: "Rpt-25", insurer: "Simah", records: 200 },
    { src: "Rpt-26", insurer: "Indwe", records: 2394 },
    { src: "Rpt-27", insurer: "Enviroserve", records: 203 },
    { src: "Rpt-28", insurer: "BornmanMarlow", records: 138 },
  ],
};
